import { useEffect, useRef, useState } from "react";
import {
  getNewsRelatedList,
  getSahamRelatedNewsList,
  getSingleNews,
} from "../../services/news/news.service";
import toast from "react-hot-toast";
import NewsBar from "../../components/product/NewsBar";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import styles from "./Product.module.css";
import Title from "../../components/title";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Heading from "../../components/heading/heading";

const NewsDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const mainNewsRef = useRef();
  let [news, setNews] = useState(null);
  let [isSahamdaran, setIsSahamdaran] = useState(false);
  let [related, setRelated] = useState([]);
  let [breadCrumbItems, setBreadCrumbItems] = useState([]);
  let [isRelatedFinished, setIsRelatedFinished] = useState(false);
  let [activeThumbIndex, setActiveThumbIndex] = useState(0);
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const handleNext = () => {
    const tmpIndex = index + 1;
    setIndex(tmpIndex % news.attachment_files.length);
  };
  const handlePrev = () => {
    const tmpIndex = index - 1;
    setIndex(tmpIndex < 0 ? news.attachment_files.length - 1 : tmpIndex);
  };
  useEffect(() => {
    let tempSaham = false;
    if (window.location.href.indexOf("/partners") >= 0) {
      setIsSahamdaran(true);
      tempSaham = true;
    } else {
      setIsSahamdaran(false);
    }
    getSingleNews(id).then(({ data }) => {
      if (typeof data.data === "object" && data.data !== null) {
        setNews(data.data);

        setBreadCrumbItems([
          { title: "خانه", url: "/" },
          {
            title:
              window.location.href.indexOf("/retired") >= 0
                ? "اخبار بازنشستگان"
                : window.location.href.indexOf("/partners") >= 0
                ? "اخبار سهامداران"
                : "اخبار",
            url:
              window.location.href.indexOf("/retired") >= 0
                ? "/retired/news/list"
                : window.location.href.indexOf("/partners") >= 0
                ? "/partners/news/list"
                : "/news/list",
          },
          { title: data.data.title, url: "/news/show/" + data.data.id },
        ]);
        const catsId = [];

        for (let cat of data.data.category) {
          catsId.push(cat.Id);
        }
        if (tempSaham) {
          getSahamRelatedNewsList(data.data.id, catsId).then(({ data }) => {
            setIsRelatedFinished(true);
            setRelated((data && data.data) || []);
          });
        } else {
          getNewsRelatedList(data.data.id, catsId).then(({ data }) => {
            setIsRelatedFinished(true);
            setRelated((data && data.data) || []);
          });
        }
      } else {
        toast.error("خبری با این مشخصات یافت نشد");
        const doesAnyHistoryEntryExist = location.key !== "default";
        setTimeout(() => {
          if (doesAnyHistoryEntryExist) {
            navigate(-1);
          } else {
            navigate("/");
          }
        }, 1000);
      }
    });
  }, [id]);
  return (
    <>
      {news && news?.title ? <Title title={news?.title} /> : null}
      <div className={`${styles.newsContainer} ${"container"}`}>
        <div className={styles.newsWrapper}>
          <div className={"row"}>
            <div className={"col-xs-12"}>
              <BreadCrumb items={breadCrumbItems} />
            </div>
            <div className={"col-xs-12 col-md-12"}>
              <div className={styles.newsWrapper}>
                {news && news?.title ? (
                  <div className={"row"}>
                    {!isSahamdaran && (
                      <div className={"col-xs-12 col-md-6 pull-left"}>
                        <div
                          className={
                            Array.isArray(news?.attachment_files) &&
                            news?.attachment_files.length === 0
                              ? `${styles.newsImage} ${styles.newsDefaultWrapper}`
                              : styles.newsImage
                          }
                        >
                          {Array.isArray(news?.attachment_files) &&
                            news?.attachment_files.length > 1 && (
                              <>
                                <div className={styles.arrowsForChange}>
                                  <div onClick={handlePrev}>
                                    <i className="fa fa-arrow-right" />
                                  </div>
                                  <div onClick={handleNext}>
                                    <i className="fa fa-arrow-left" />
                                  </div>
                                </div>
                              </>
                            )}
                          <img
                            ref={mainNewsRef}
                            src={
                              Array.isArray(news?.attachment_files) &&
                              news?.attachment_files.length > 0
                                ? news?.attachment_files[index]
                                    .server_relative_url
                                : "../../../assets/image/logo.png"
                            }
                            alt={news?.title}
                          />
                        </div>
                        {Array.isArray(news?.attachment_files) &&
                          news?.attachment_files.length > 1 && (
                            <div className={styles.thumbs}>
                              {news.attachment_files.map((item, index) => (
                                <div
                                  onClick={() => {
                                    setActiveThumbIndex(index);
                                    mainNewsRef.current.src =
                                      item.server_relative_url;
                                  }}
                                  className={
                                    index === activeThumbIndex
                                      ? styles.activeThumb
                                      : styles.thumb
                                  }
                                  key={`news-thumb-${index}`}
                                >
                                  <img
                                    src={item.server_relative_url}
                                    alt={news.title}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                      </div>
                    )}
                    <div
                      className={
                        isSahamdaran
                          ? "col-xs-12 col-md-12"
                          : "col-xs-12 col-md-6 pull-right"
                      }
                    >
                      <div className={styles.newsInfo}>
                        <ul
                          className={`"d-flex justify-content-around" ${styles.newsInfoList}`}
                        >
                          <li>
                            {!isSahamdaran && (
                              <>
                                <i className={"fa fa-calendar"}></i> تاریخ
                                انتشار : {news?.publish_date}
                              </>
                            )}
                          </li>
                          <li>
                            <i className={"fa fa-file"}></i> موضوع :{" "}
                            {news?.category.map((cat) => (
                              <span className={styles.catBox}>
                                {cat.Title}&nbsp;&nbsp;
                              </span>
                            ))}
                          </li>
                        </ul>
                      </div>

                      <h1 id={styles.newsTitle}>
                        {isSahamdaran &&
                        Array.isArray(news?.attachment_files) &&
                        news?.attachment_files.length > 0 ? (
                          <div className={styles.newsRowTitle}>
                            <div>{news?.title}</div>
                            <div>
                              <a
                                href={
                                  news?.attachment_files[0].server_relative_url
                                }
                                className={styles.newsLink}
                                target="_blank"
                                download={true}
                              >
                                <i className="fa fa-download"></i> دانلود
                              </a>
                            </div>
                          </div>
                        ) : (
                          news?.title
                        )}
                      </h1>
                      <div id={styles.newsShortDescription}>
                        <i className={"fa fa-quote-right large-quote"}></i>
                        {news?.short_description}
                      </div>
                    </div>
                    <div className={"col-xs-12"}>
                      <div
                        id={styles.newsContent}
                        dangerouslySetInnerHTML={{
                          __html: news ? news?.description : null,
                        }}
                      ></div>
                    </div>
                  </div>
                ) : (
                  <div className="loading-wrapper">
                    <img
                      src={"../../../assets/image/loading.svg"}
                      alt={"در حال بار گذاری"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className={"col-xs-12 col-md-12 pull-right"}>
            <Heading title={"اخبار مرتبط"} icon={"fa fa-rss"} />
            <div id={styles.relatedNewsWrapper}>
              <div className="row">
                {related && related.length > 0 ? (
                  related.map((item, key) => {
                    return (
                      <div className="col-md-6 col-xs-12 pull-right">
                        <NewsBar key={`main-page-news-el-${key}`} news={item} />
                      </div>
                    );
                  })
                ) : isRelatedFinished ? (
                  <div className={styles.isRelatedFinished}>
                    اخبار مرتبطی موجود نمیباشد
                  </div>
                ) : (
                  <div className="loading-wrapper">
                    <img
                      src={"../../../assets/image/loading.svg"}
                      alt={"در حال بار گذاری"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsDetails;
